export default __webpack_public_path__ + "static/movilidad-346823ad169cb441b5cdfda72d85fe3a.png";